<template>
  <div class="">
    <Navbar />
    <section class="admin-content">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-edit-2" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Edit Enrollee</h4>
              <small style="opacity: .8;">Update enrollee bio data and coverage information</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">
        <div class="row">
          <div class="col-lg-10 mx-auto">

            <div class="card table-card shadow mb-4">
              <div class="form-card-header">
                <div class="section-number">1</div>
                <div>
                  <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Personal Data</p>
                  <small style="color:rgba(255,255,255,.7);">Update enrollee bio information</small>
                </div>
              </div>
              <div class="card-body">

                <div class="form-row">
                  <div class="col-md-6" v-if="!is313923">
                    <div class="form-group">
                      <label class="info-label d-block mb-1">Sector Type: {{ auth_user.sectorType }}</label>
                      <select class="form-control" v-model="auth_user.sectorType">
                        <option value="formal">Formal Sector</option>
                        <option value="informal">Informal Sector</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="info-label d-block mb-1">Plan Type <span class="text-danger">*</span></label>
                      <select class="form-control" required v-model="auth_user.plan_type">
                        <option value="Family">Family</option>
                        <option value="Individual">Individual</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="info-label d-block mb-1" for="editUserProgramSelect">Program</label>
                      <select class="form-control" id="editUserProgramSelect" v-model="auth_user.sector" @change="onProgramChange">
                        <option :value="name" v-for="name in programOptions" :key="name">{{ name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6" v-if="hasSubPrograms">
                    <div class="form-group">
                      <label class="info-label d-block mb-1">Sub-Program <span class="text-danger">*</span></label>
                      <select class="form-control" v-model="auth_user.sectorType">
                        <option value="">-- Select Sub-Program --</option>
                        <option v-for="sub in subProgramOptions" :key="sub" :value="sub">{{ sub }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Special Needs</label>
                    <select class="form-control" v-model="auth_user.category_of_vulnerable_group">
                      <option value="">-- None --</option>
                      <option v-for="name in vulnerableOptions" :key="name" :value="name">{{ name }}</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Surname</label>
                    <input type="text" v-model="auth_user.lastname" class="form-control" placeholder="Last Name" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">First Name</label>
                    <input type="text" v-model="auth_user.firstname" class="form-control" placeholder="First Name" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Middle Name</label>
                    <input type="text" v-model="auth_user.middlename" class="form-control" placeholder="Middle Name" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Email</label>
                    <input type="email" class="form-control" placeholder="Email" v-model="auth_user.email" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Phone Number</label>
                    <input v-phone type="text" class="form-control" placeholder="Phone Number" v-model="auth_user.phone_number" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Enrollee ID</label>
                    <input type="text" class="form-control" readonly placeholder="Enrollee ID" v-model="auth_user.id_card_number" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">NIN</label>
                    <input type="text" class="form-control" placeholder="NIN" v-model="auth_user.nimc_number" />
                  </div>

                  <div class="form-group col-md-6" v-if="user.user_role != 0">
                    <label class="info-label d-block mb-1">Computer Number / Salary Number</label>
                    <input type="text" class="form-control" placeholder="Computer Number" v-model="auth_user.salary_number" />
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Establishment: {{ auth_user.place_of_work }}</label>
                    <select class="form-control" @change="getDepts" required v-model="auth_user.place_of_work">
                      <option v-for="mda in mdas" :key="mda.name" :value="mda.name">{{ mda.name }}</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Gender</label>
                    <select class="form-control" v-model="auth_user.gender">
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Marital Status</label>
                    <select class="form-control" v-model="auth_user.marital_status">
                      <option value="Married">Married</option>
                      <option value="Widow">Widow</option>
                      <option value="Single">Single</option>
                      <option value="Divorced">Seperated</option>
                      <option value="Divorced">Divorced</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">HMO <span class="text-danger">*</span></label>
                    <select class="form-control" required v-model="auth_user.org_id">
                      <option v-for="org in tpas" v-bind:key="org" :value="org.id">{{ org.organization_name }}</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Date of Birth <span class="text-danger">*</span></label>
                    <input type="date" class="form-control" v-model="auth_user.dob" />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">
                      Date of Expiry: <strong>{{ auth_user.expiry_date }}</strong> <span class="text-danger">*</span>
                    </label>
                    <input type="date" class="form-control" v-model="auth_user.expiry_date" />
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">
                      Date of First Appointment: {{ auth_user.date_of_entry }}
                    </label>
                    <input type="date" required class="form-control" v-model="auth_user.date_of_entry" />
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">
                      Date of Card Issued: {{ auth_user.date_id_card_issued }}
                    </label>
                    <input type="date" required class="form-control" v-model="auth_user.date_id_card_issued" />
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Blood Group</label>
                    <select class="form-control" v-model="auth_user.blood">
                      <option :value="null">Not known</option>
                      <option v-for="g in bloodGroupOptions" :key="g.value" :value="g.value">{{ g.label }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">LGA</label>
                    <select class="form-control" v-model="auth_user.localgovt" @change="fetchWards">
                      <option v-for="lga in lga_states" v-bind:key="lga.id" :value="lga.id">{{ lga.local_name }}</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Ward</label>
                    <select class="form-control" v-model="auth_user.ward">
                      <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">{{ ward.ward_name }}</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Community</label>
                    <input type="text" class="form-control" v-model="auth_user.community" placeholder="Community Name" />
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Occupation</label>
                    <v-select v-model="auth_user.occupation" :options="occupations" :value="auth_user.occupation"></v-select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Highest Qualification</label>
                    <v-select v-model="auth_user.education" :options="qualifications" :value="auth_user.education"></v-select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="info-label d-block mb-1">Home Address</label>
                    <input type="text" class="form-control" v-model="auth_user.address1" placeholder="Address" />
                  </div>
                </div>

                <div class="pt-3 border-top">
                  <button type="submit" class="btn btn-submit px-5" @click="editUser">
                    <i class="fe fe-save mr-1"></i> Save Changes
                  </button>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </section>
  </div>
</template>

<script>
  // @ is an alias to /src
  // import Settings from '@/components/Settings.vue'
  import Navbar from "@/views/Navbar.vue";
  import Loading from "vue-loading-overlay";
  let agency = JSON.parse(localStorage.getItem("agency"));
  import occupations from "@/json/occupations.json";
  import qualifications from "@/json/qualifications.json";
  import sectorsJson from "@/json/sectors_dynamic.json";
  import vulnerablesJson from "@/json/vulnerables.json";
  import subProgramsJson from "@/json/sub_programs.json";


  export default {
    // name: 'Home',
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        agencyProgrammes: [],
        auth_user: "",
        lastSector: "",
        programChanged: false,
        user: null,
        image: "",
        sector: "",
        wards: "",
        occupations: occupations,
        qualifications: qualifications,
        tpas: "",
        mdas: "",
        lga_states: "",
        isLoading: false,
        fullPage: true,
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));

      // this.axios
      //   .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
      //   .then((response) => {
      //     this.auth_user = response.data.user;
      //     console.log(response);


      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    computed: {
      // Blood groups with the Rhesus factor, as on the enrolment forms; a stored value outside the list (older
      // records saved as "A", "O" …) stays selectable so saving the form doesn't change it.
      bloodGroupOptions() {
        const groups = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].map((g) => ({ value: g, label: g }));
        const current = this.auth_user && this.auth_user.blood;
        if (current && !groups.some((g) => g.value === current)) groups.unshift({ value: current, label: current + " (as saved; please update)" });
        return groups;
      },
      is313923() {
        return String(agency.id) === "313923";
      },
      currentSector() {
        return (this.auth_user && this.auth_user.sector) || "";
      },
      programOptions() {
        let names = sectorsJson
          .filter((x) => x.agency_id == agency.id)
          .map((x) => x.name);
        // plus the agency's plans (Manage Plans) and programmes enrollees are on
        this.agencyProgrammes.forEach((name) => {
          const value = String(name || "").trim();
          if (value && !names.some((n) => n.toLowerCase() === value.toLowerCase())) names.push(value);
        });
        if (this.currentSector && !names.includes(this.currentSector)) {
          names.unshift(this.currentSector);
        }
        return names;
      },
      subProgramOptions() {
        let map = subProgramsJson[String(agency.id)] || {};
        let subs = (map[this.currentSector] || []).slice();
        let current = this.auth_user && this.auth_user.sectorType;
        if (current && !subs.includes(current) && !this.programChanged) {
          subs.unshift(current);
        }
        return subs;
      },
      hasSubPrograms() {
        let map = subProgramsJson[String(agency.id)] || {};
        return !!map[this.currentSector];
      },
      vulnerableOptions() {
        let names = vulnerablesJson
          .filter(
            (x) => x.agency_id == agency.id && x.sector == this.currentSector
          )
          .map((x) => x.name);
        let current = this.auth_user && this.auth_user.category_of_vulnerable_group;
        if (current && !names.includes(current) && !this.programChanged) {
          names.unshift(current);
        }
        return names;
      },
    },
    methods: {
      // Plans of the agency (Manage Plans) and programmes enrollees are on without a plan.
      getAgencyProgrammes() {
        this.axios
          .get(`/api/v1/auth/agency-plans`)
          .then((response) => {
            const data = (response.data && response.data.data) || {};
            this.agencyProgrammes = [
              ...(data.plans || []).map((p) => p.title),
              ...(data.programmes_without_plan || []).map((p) => p.name),
            ];
          })
          .catch(() => { this.agencyProgrammes = []; });
      },
      onProgramChange() {
        let oldSector = this.lastSector;
        let newSector = this.auth_user.sector;
        this.programChanged = true;
        if (this.is313923) {
          // sub-program belongs to the old program, force a fresh choice
          this.auth_user.sectorType = "";
        } else if (this.auth_user.sectorType === oldSector) {
          this.auth_user.sectorType = newSector;
        }
        let valid = vulnerablesJson.some(
          (x) =>
            x.agency_id == agency.id &&
            x.sector == newSector &&
            x.name == this.auth_user.category_of_vulnerable_group
        );
        if (!valid) this.auth_user.category_of_vulnerable_group = "";
        this.lastSector = newSector;
      },
      getUser() {
        this.axios
          .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
          .then((response) => {
            this.auth_user = response.data.user;
            this.lastSector = this.auth_user.sector || "";
            this.programChanged = false;
              this.fetchWards();
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/${agency.state}`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/${this.auth_user.localgovt}`)
          .then((response) => {
            this.wards = response.data.data;
            console.log(response);
            this.getProvidersByLGAs();
          })
          .catch((error) => {
            console.error(error);
          });
      },

      editUser() {
        this.user = JSON.parse(localStorage.getItem("user"));
        if (this.programChanged && this.hasSubPrograms && !this.auth_user.sectorType) {
          this.$toasted.error("Please select a Sub-Program for the new Program.", {
            position: "top-center",
            duration: 4000,
          });
          return;
        }
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/editProfile/${this.$route.params.id}`, {
            firstname: this.auth_user.firstname,
            lastname: this.auth_user.lastname,
            middlename: this.auth_user.middlename,
            nimc_number: this.auth_user.nimc_number,
            email: this.auth_user.email,
            type: this.auth_user.type,
            plan_type: this.auth_user.plan_type,
            category_of_vulnerable_group:
              this.auth_user.category_of_vulnerable_group,
            state: agency.state,
            localgovt: this.auth_user.localgovt,
            ward: this.auth_user.ward,
            dob: this.auth_user.dob,
            expiry_date: this.auth_user.expiry_date,
            salary_number: this.auth_user.salary_number,
            gender: this.auth_user.gender,
            marital_status: this.auth_user.marital_status,
            occupation: this.auth_user.occupation,
            education: this.auth_user.education,
            community: this.auth_user.community,
            genotype: this.auth_user.genotype,
            institutional_id: this.auth_user.institutional_id,
            id_card_number: this.auth_user.id_card_number,
            user_image: this.auth_user.user_image,
            provider_id: this.auth_user.provider_id,
            sector: this.auth_user.sector,
            sectorType: this.auth_user.sectorType,
            blood: this.auth_user.blood,
            org_id: this.auth_user.org_id,
            date_of_entry: this.auth_user.date_of_entry,
            date_id_card_issued: this.auth_user.date_id_card_issued,
            place_of_work: this.auth_user.place_of_work,
            password: this.auth_user.password,
            phone_number: this.auth_user.phone_number,
            agency_name: this.auth_user.agency_name,
            address1: this.auth_user.address1,
            agencyAddress: this.auth_user.agencyAddress,
            agencyWebsite: this.auth_user.agencyWebsite,
          })
          .then((response) => {
            console.log(response);
            this.$breadstick.notify("User updated Successfully!", {
              position: "top-right",
            });
            this.isLoading = false;
          })
          .catch((error) => {

            this.isLoading = false;
            let data = (error.response && error.response.data) || {};
            let message = data.errors
              ? JSON.stringify(data.errors)
              : data.message || "Could not reach the server. If you changed the photo, try a smaller one.";
            this.$toasted.error(message, {
              position: "top-center",
              duration: 5000,
            });


          });
      },

      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministries/${agency.id}`)
          .then((response) => {
            this.mdas = response.data.data;
            console.log(response.data);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getTPAs() {
        this.user = JSON.parse(localStorage.getItem("user"));

        this.axios
          .get(`/api/v1/auth/org_agency/${agency.id}`)
          .then((response) => {
            this.tpas = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getDepts() {
        if (!this.auth_user || !this.auth_user.place_of_work || !Array.isArray(this.mdas)) {
          return;
        }

        const selectedMda = this.mdas.find((mda) => {
          if (!mda) return false;
          if (typeof this.auth_user.place_of_work === "object") {
            return mda.id === this.auth_user.place_of_work.id;
          }
          return mda.name === this.auth_user.place_of_work;
        });

        if (selectedMda) {
          this.auth_user.org_id = selectedMda.hmo_id || selectedMda.org_id || "";
        }
      },
    },
    created() {
      this.getAgencyProgrammes();
      this.fetchLga();
      this.getUser();
      this.getMDAs();
      this.getTPAs();
      // this.fetchWards();
    },
  };
</script>
